<template>
    <div class="total-ranking card p-relative">
        <Loading :loading="loading" />
        <div class="top">
            <div class="flex-row items-center">
                <div class="title flex-wrap" v-html="$translate('TOTAL_RANKING')" />
                <div class="divider flex-wrap">ㅣ</div>
                <div class="desc" v-html="$translate('TOTAL_RANKING_DESC')" />
            </div>
        </div>
        <div v-if="!$store.getters.isMobile" class="p-l-20 p-r-20">
            <div class="ranking-items" :key="item.title" v-for="(item, idx) in items">
                <div class="title" v-html="$translate(item.title)" />
                <div class="desc" v-html="$translate(item.desc)" />
                <div class="flex-row">
                    <TotalRankingCard
                        :rank="idx + 1"
                        :user="obj.user"
                        :statKey="$translate(obj.statKey)"
                        :statValue="obj.statValue"
                        :hourlyPay="obj.hourlyPay"
                        :key="idx"
                        v-for="(obj, idx) in item.obj"
                    />
                </div>
                <div v-if="idx < items.length - 1" class="hr" />
            </div>
        </div>
        <Tabs v-else :tabs="items" @onClickTab="o => onClickTab(o.index)" class="m-l-20 m-r-20" />
        <Carousel
            ref="carousel"
            v-if="$store.getters.isMobile"
            :per-page="1"
            @pageChange="onClickTab"
            :navigate-to="selectedTabIdx"
        >
            <Slide class="ranking-items" :key="item.title" v-for="item in items">
                <div class="desc" v-html="$translate(item.desc)" />
                <TotalRankingCard
                    :rank="idx + 1"
                    :user="obj.user"
                    :statKey="$translate(obj.statKey)"
                    :statValue="obj.statValue"
                    :hourlyPay="obj.hourlyPay"
                    :key="idx"
                    v-for="(obj, idx) in item.obj"
                />
            </Slide>
        </Carousel>
    </div>
</template>

<script>
import TotalRankingCard from './TotalRankingCard'

export default {
    name: 'TotalRanking',
    components: { TotalRankingCard },
    data: () => ({
        loading: false,
        selectedTabIdx: 0,
        items: [],
    }),
    computed: {
        totalRanking() {
            return this.$store.getters.totalRanking
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        initItems() {
            this.items = [
                {
                    title: 'TOTAL_RANKING_MATCHING',
                    desc: 'TOTAL_RANKING_MATCHING_DESC',
                    obj: this.totalRanking.num_rewards_week.map(stat => ({
                        user: stat.user,
                        statKey: 'TOTAL_RANKING_MATCHING',
                        statValue: `${stat.num_rewards_week}건`,
                    })),
                    selected: this.selectedTabIdx === 0,
                },
                {
                    title: 'TOTAL_RANKING_MATCHING_PER_HOUR',
                    desc: 'TOTAL_RANKING_MATCHING_PER_HOUR_DESC',
                    obj: this.totalRanking.num_rewards_per_hour.map(stat => ({
                        user: stat.user,
                        statKey: 'TOTAL_RANKING_MATCHING_PER_HOUR',
                        statValue: `${Math.round(stat.num_rewards_per_hour * 10) / 10}건`,
                        hourlyPay: `${this.$options.filters.currency(stat.hourly_pay)}원`,
                    })),
                    selected: this.selectedTabIdx === 1,
                },
                {
                    title: 'TOTAL_RANKING_REFUND_RATIO',
                    desc: 'TOTAL_RANKING_REFUND_RATIO_DESC',
                    obj: this.totalRanking.refund_ratio.map(stat => ({
                        user: stat.user,
                        statKey: 'TOTAL_RANKING_REFUND_RATIO',
                        statValue: `${stat.refund_ratio}%`,
                    })),
                    selected: this.selectedTabIdx === 2,
                },
            ]
        },
        async init() {
            try {
                this.loading = true
                await this.$store.dispatch('loadTotalRanking')
                this.initItems()
            } catch (e) {}
            this.loading = false
        },
        onClickTab(index) {
            this.items.forEach((item, itemIdx) => {
                item.selected = itemIdx === index
            })
            this.$refs.carousel.goToPage(index)
        },
    },
}
</script>
